import Vue from 'vue';
import Vuex from 'vuex';
import user from './user';
import systems from './systems';
import menus from './menus';
import status from './status';
import endpoints from './endpoints';
import collectors from './collectors';
import crossorg from './crossorg';
import accountSettings from './account-settings';
import singleSignOn from './single-signon';
import VuexPersist from 'vuex-persist/dist/umd';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.sessionStorage, // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  reducer: (state) => ({
    user: {
      isLoggedIn: state.user.isLoggedIn,
      authToken: state.user.authToken,
      refreshToken: state.user.refreshToken,
      userInfo: state.user.userInfo,
      refreshTimer: state.user.refreshTimer,
      organizations: state.user.organizations,
      orgContext: state.user.orgContext,
      orgMiscData: state.user.orgMiscData,
      orgSelectionLock: state.user.orgSelectionLock,
      allRoles: state.user.allRoles,
      currentUserRoles: state.user.currentUserRoles,
      users: state.user.users,
      ccoUsers: state.user.ccoUsers,
      appconfigs: state.user.appconfigs,
      orgContextTimezone: state.user.aorgContextTimezone,
      ccoOrg: state.user.accoOrg,
      collectorGAVersion: state.collectors.collectorGAVersion,
      pagination: state.user.pagination
    },
    menus: state.menus, 
    status: state.status, 
    systems: { typeCodes: state.systems.typeCodes, pagination: state.systems.pagination },
    accountSettings: { orgContacts: state.accountSettings.orgContacts },
    endpoints: { pagination: state.endpoints.pagination, agPagination: state.endpoints.agPagination},
    }
  ),
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

export const store = new Vuex.Store({
  modules: {
    user,
    systems,
    menus,
    endpoints,
    collectors,
    status,
    crossorg,
    accountSettings,
    singleSignOn
  },
  plugins: [vuexLocalStorage.plugin]
});